import React from 'react';
import { Name } from '../../facades/Icon';
import { Icon } from '../../facades';

export interface IconComponent {
  icon: string;
  size?: "xs" | "lg" | "sm" | "1x" | "2x" | "3x" | "4x" | "5x" | "6x" | "7x" | "8x" | "9x" | "10x",
  lib: "fal" | "fas",
  gradientType?: 'light' | 'dark'
  
}
export const IconComponent = ({icon, size, lib, gradientType, ...props}: IconComponent) => {
  const iconName = icon as Name
return (
  <Icon
    icon={iconName}
    size={size}
    lib={lib}
    gradientType={gradientType}
    {...props}
  />
)
}
export default IconComponent;